import { Component, Input, OnInit } from '@angular/core';
import { PostDO } from '../../common/data-objects/PostDO';

@Component({
  selector: 'app-review-thumbnail',
  templateUrl: './review-thumbnail.component.html',
  styleUrls: ['./review-thumbnail.component.scss']
})
export class ReviewThumbnailComponent implements OnInit {
  @Input() postData: PostDO;

  constructor() { }

  ngOnInit() {
  }

  get postLink(): string[] {
    return [this.postData.slug];
  }

  get postImage(): string {
    return `url(${this.postData.featuredImageSizes && this.postData.featuredImageSizes.mediumLarge ? this.postData.featuredImageSizes.mediumLarge : 'assets/logo.svg'})`;
  }
}
